@if (notification()) {
<div class="notification notification-{{ notification()?.type }} slide-in">
  <div class="notification-content">
    <ion-icon [name]="getIconClass()" class="notification-icon"></ion-icon>
    <span class="notification-message" innerHTML="{{ notification()?.message | translate }}"></span>
  </div>
</div>
}
